<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { formatDayTime, formatDate } from '@/helper'

  export default {
    name: 'EventPreview',
    props: {
      event: Object,
    },
    methods: {
      getEventTime(start, end) {
        const startTime = start ? formatDayTime(start) : ''
        const endTime = end && end !== start ? formatDayTime(end) : ''
        const untilDivider = start && end ? ' - ' : ''
        return `${startTime}${untilDivider}${endTime} ${this.$t('event.time')}`
      },
      getEventDate(start, end) {
        const startDate = start ? formatDate(start) : ''
        const endDate = end && end !== start ? formatDate(end) : ''
        const untilDivider = start && end ? ' - ' : ''
        return `${startDate}${untilDivider}${endDate}`
      },
    },
  }
</script>
